<header
  style="
    background-color: #273385;
    position: fixed;
    height: 60px;
    padding: 10px;
  "
>
  <div class="row">
    <div class="col-md-4 col-4">
      <div class="m-l-auto center-para">
        <span
          ><a href="https://sacoronavirus.co.za/; " target="_blank"
            ><h6 class="copyright-text text-left text-white">
              <i
                _ngcontent-serverapp-c26=""
                aria-hidden="true"
                class="fa fa-globe"
              ></i>
              Covid-19 Govt portal
            </h6></a
          ></span
        >
      </div>
    </div>
    <div class="col-md-8 col-8">
      <div class="m-l-auto center-para">
        <span
          ><a href="mailto:info@bloubergphysio.co.za?subject:enquiry text"
            ><h6
              class="copyright-text text-right text-white"
              style="text-transform: lowercase"
            >
              <i
                _ngcontent-serverapp-c26=""
                aria-hidden="true"
                class="fa fa-envelope"
                style="padding-right: 10px"
              ></i>
              info@bloubergphysio.co.za
            </h6></a
          ></span
        >
        <span
          ><h6 class="copyright-text text-right text-white">
            <i
              _ngcontent-serverapp-c26=""
              aria-hidden="true"
              class="fa fa-phone"
              style="padding-right: 10px"
            ></i>
            Table View - <a href="tel:021 557 4515">021 557 4515</a>
          </h6></span
        >
        <span
          ><h6 class="copyright-text text-right text-white">
            <i
              _ngcontent-serverapp-c26=""
              aria-hidden="true"
              class="fa fa-phone"
              style="padding-right: 10px"
            ></i>
            Milnerton - <a href="tel:021 551 1494 ">021 551 1494 </a>
          </h6></span
        >
      </div>
    </div>
  </div>
</header>
